import React, { PropsWithChildren } from 'react';

type TableEditProps = {

};

function TableEdit( { children }: PropsWithChildren<TableEditProps> ) {
  return (
    <table className="table table-responsive table--edit">
      {children}
    </table>
  );
}

export default TableEdit;
